<template>
    <v-card class="mx-auto" shaped elevation="7" min-height="700px">
        <v-card-title>
            Carga Foto De Inspección
            <ModalCargaFotoInspeccionComponent :load="obModal.abrirModal" :listGeneral="listGeneral" :obForm="obModal"/>
        </v-card-title>
        <v-card-text>
            <v-container fluid grid-list-md>
                <v-row dense>
                    <v-col cols="12" sm="3">
                        <v-dialog ref="dialogFechaDesde" v-model="objDate.desde.abrirModal"
                            :return-value.sync="objSearch.fechaDesde" persistent width="340px">
                            <template v-slot:activator="{ on }">
                                <v-text-field color="textbox" v-model="objSearch.fechaDesde" label="Fecha Desde *"
                                    prepend-inner-icon="event" readonly outlined dense v-on="on" />
                            </template>
                            <v-date-picker color="primary" v-model="objSearch.fechaDesde" scrollable locale="es">
                                <v-spacer></v-spacer>
                                <v-btn outlined dense rounded color="danger" @click="objDate.desde.abrirModal = false"
                                    v-html="'Salir'"></v-btn>
                                <v-btn rounded dark color="primary"
                                    @click="$refs.dialogFechaDesde.save(objSearch.fechaDesde);"
                                    v-html="'Guardar Fecha'"></v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-col>
                    <v-col cols="12" sm="3">
                        <v-dialog ref="dialogFechaHasta" v-model="objDate.hasta.abrirModal"
                            :return-value.sync="objSearch.fechaHasta" persistent width="340px">
                            <template v-slot:activator="{ on }">
                                <v-text-field color="textbox" v-model="objSearch.fechaHasta" label="Fecha Hasta *"
                                    prepend-inner-icon="event" readonly outlined dense v-on="on" />
                            </template>
                            <v-date-picker color="primary" v-model="objSearch.fechaHasta" scrollable locale="es">
                                <v-spacer></v-spacer>
                                <v-btn outlined dense rounded color="danger" @click="objDate.hasta.abrirModal = false"
                                    v-html="'Salir'"></v-btn>
                                <v-btn rounded dark color="primary"
                                    @click="$refs.dialogFechaHasta.save(objSearch.fechaHasta);"
                                    v-html="'Guardar Fecha'"></v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-col>
                    <v-col cols="12" sm="3">
                        <v-tooltip top color="primary">
                                <template v-slot:activator="{ on }">
                                    <v-btn fab dark small color="primary" @click="onListarInpeccion" v-on="on"
                                            :disabled="disabled">
                                            <v-icon dark>search</v-icon>
                                    </v-btn>
                                </template>
                                <span>Buscar</span>
                        </v-tooltip>
                    </v-col>
                    <v-col cols="12" sm="3">
                        <!-- <v-text-field label="N° Orden De Inspección" color="textbox" v-model="objSearch.nroOrden" outlined dense  /> -->
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="6" />
                    <v-col cols="12" sm="6">
                        <v-text-field label="Buscar" color="textbox" v-model="objSearch.search" clearable dense
                            prepend-inner-icon="search" />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12">
                        <v-data-table :search="objSearch.search" :headers="listGeneral.cabecera"
                            :items="listGeneral.detalle" class="elevation-3">

                            <template v-slot:item.name="{ item }">
                                <v-btn class="ma-2" text icon color="primary" @click="edit(item)">
                                    <v-icon small>edit</v-icon>
                                </v-btn>
                            </template>

                            <template v-slot:no-results>
                                Tu búsqueda de "<span v-html="objSearch.search"></span>" no arrojó resultados.
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name: 'CargaFotoInspeccionView',
        components:{
            ModalCargaFotoInspeccionComponent: () => import('@/components/aseguradora/ModalCargaFotoInspeccionComponent.vue')
        },
        data: () => ({
            objDate: {
                desde: {
                    abrirModal: false
                },
                hasta: {
                    abrirModal: false
                }
            },
            objSearch: {
                opcion: 'LISTAR_PENDIENTE_X_ASEGURADORA',
                search: '',
                fechaDesde: moment('2019-05-01').format('YYYY-MM-DD'),
                fechaHasta: moment().format('YYYY-MM-DD'),
                nroOrden:null
            },
            obModal:{
                abrirModal: false,
            },
            listGeneral:{
                cabecera:[],
                detalle:[]
            },
            parametro:{},
            disabled:false
        }),
        created(){
            var error = 'E';

            axios.post(`${BASE_URI}administrador/orden-inspeccion/cargaGeneral`)
                 .then((r)=>{
                      if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                      if(_.size(_.get(r,['data','data'],[])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }
                        this.$set(this,'listGeneral',r.data.data.listas);
                        this.$set(this,'parametro',r.data.data.parametro);
                        return this.onListarInpeccion('L');
                 })
                 .catch((e) => { 
                    mensajesAlerta(e,error) 
                 });
        },
        methods:{
            edit(objeto){
                this.$set(this,'obModal',_.merge({},objeto,{abrirModal:true}));
            },
            onListarInpeccion(event){
                if(!_.isUndefined(event)){
                    var error = 'E';
                    this.disabled = true;
    
                    axios.post(`${BASE_URI}administrador/orden-inspeccion/listar-agendada`,_.omit(this.objSearch,'search'))
                         .then((r)=>{
                            if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if(_.size(_.get(r,['data','data'],[])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }
                                this.listGeneral.detalle = r.data.data;
                                this.listGeneral.listInstruccionFoto = _.map(_.cloneDeep(this.listGeneral.listInstruccionFoto),(v) => {
                                                                                v.index = _.uniqueId();
                                                                                v.idEstado = this.parametro.id_estado_default
                                                                                return v;
                                                                        });
                                this.disabled = false;
                         })
                         .catch((e) => { 
                             this.disabled = false;
                            mensajesAlerta(e,error); 
                        });
                }
            },
            reset(){
                this.obModal = { abrirModal: false };
                this.onListarInpeccion('L');
            }
        },
        provide(){
            return{
                close: this.reset
            }
        }
    }
</script>
